var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    "class": [{
      'required-field-placeholder-hint': _vm.placeholderHintActive
    }, _vm.inputStyle === 'tailwind' ? 'input-style-tailwind' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    ref: "textField",
    attrs: {
      "id": _vm.inputId,
      "disabled": _vm.disabled,
      "error-messages": _vm.errorMessages,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "persistent-placeholder": _vm.persistentPlaceholder,
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "hide-details": _vm.hideDetails
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeydown
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }), _vm.showSuggestions && _vm.suggestions.length > 0 ? _c('div', {
    staticClass: "suggestions-dropdown",
    attrs: {
      "role": "listbox",
      "aria-label": "Suggestions d’adresses"
    }
  }, [_c('v-list', {
    staticClass: "address-suggestions-list",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.suggestions, function (suggestion, index) {
    return _c('v-list-item', {
      key: suggestion.place_id,
      staticClass: "address-suggestion",
      "class": {
        'v-list-item--active': index === _vm.selectedIndex
      },
      attrs: {
        "role": "option",
        "aria-selected": index === _vm.selectedIndex
      },
      on: {
        "click": function click($event) {
          return _vm.selectSuggestion(suggestion);
        },
        "mouseenter": function mouseenter($event) {
          _vm.selectedIndex = index;
        },
        "mousedown": function mousedown($event) {
          $event.preventDefault();
        }
      }
    }, [_c('span', {
      staticClass: "address-suggestion-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-map-marker-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "address-suggestion-title"
    }, [_vm._v(_vm._s(_vm.suggestionTitle(suggestion)))]), _vm.suggestionSubtitle(suggestion) ? _c('v-list-item-subtitle', {
      staticClass: "address-suggestion-subtitle"
    }, [_vm._v(_vm._s(_vm.suggestionSubtitle(suggestion)))]) : _vm._e()], 1)], 1);
  }), 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }